export default "__VITE_ASSET__DDZ_cJ$Z__"